/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getMetricsOverrides';
import type { GetMetricsQueryParams } from '../../operation-overrides/getMetricsOverrides';

export type GetMetricsPathParams = NonNullable<operations['getMetrics']['parameters']['path']>;
export type { GetMetricsQueryParams };

export interface Input extends GetMetricsPathParams {
  apiVersion?: string;
  query?: GetMetricsQueryParams;
}

export async function getMetrics(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/metrics/{projectKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
